import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ACTION_TYPE } from 'models';
import { OVERVIEW_RESPONSE } from 'models/overview';

export interface OverviewType {
  baseRequest: OVERVIEW_RESPONSE; // baseRequest is the request that Parent created after Register Account
  acRequestStatus: ACTION_TYPE;
}

const initialState: OverviewType = {
  acRequestStatus: ACTION_TYPE.PENDING,
  baseRequest: null,
};

const overviewSlice = createSlice({
  name: 'overview',
  initialState,
  reducers: {
    updateBaseRequest(
      state: OverviewType,
      action: PayloadAction<OVERVIEW_RESPONSE>,
    ) {
      state.baseRequest = action.payload;
    },
    updateACRequestSitterStatus(
      state: OverviewType,
      action: PayloadAction<ACTION_TYPE>,
    ) {
      state.acRequestStatus = action.payload;
    },
  },
});

// Actions
export const { updateBaseRequest, updateACRequestSitterStatus } =
  overviewSlice.actions;

export default overviewSlice.reducer;
